<div class="tt-c-review-responses tt-u-mb--lg">
  <div v-for="sourceResponses in responsesBySource" class="tt-c-review-responses__source-wrap tt-u-mb--lg">
    <div class="tt-c-review-responses__source tt-u-mb--sm" v-html="$msg('review.response.from', [sourceResponses.source])"></div>
    <div class="tt-c-review-responses__responses tt-u-mb--md">
      <div v-for="response in sourceResponses.responses" class="tt-c-review-responses__item tt-u-mb--lg">
        <div class="tt-c-review-responses__text tt-u-mb--md" v-html="response.text"></div>
        <tt-review-byline :item="response" ugcType="rr" class="tt-c-review-responses__byline"></tt-review-byline>
      </div>
    </div>
  </div>
</div>
